import { PipeTransform, Pipe } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'translateEnum'
})

export class TranslateEnumPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(value: any, enumType: any): string {
      if (value != null && value !== '') {
            return this.translateService.instant(`${enumType}_${value}`);
        }
        return '';
    }
}